module.exports = __webpack_public_path__ + "img/chevron-double-left.dea0fcf8.svg";